import React from "react";
import webui from "@tinqin/tinqin-web-ui";
import { IComponentProps, IExtractedProps } from "Common/utils/commonTypes";

export const VideoBox: React.FC<IComponentProps> = props => {
    const data: Record<string, any> = props.data ? props.data.properties || {} : null;
    if (!data) {
        return null;
    }
    const dataProps: IExtractedProps = webui.getUtils().extractComponentProps(props, {
        additionalProps: ["videoLink", "videoId", "anchorId"]
    });
    return (
        <div
            className="video-embed-field-provider-youtube video-embed-field-responsive-video"
            id={dataProps.anchorId ? dataProps.anchorId : null}
        >
            <iframe
                width="854"
                height="480"
                frameBorder="0"
                allowFullScreen={true}
                src={dataProps.videoLink}
                title="Embedded Video"
            ></iframe>
        </div>
    );
};

export default webui.connectComponent()(VideoBox);
